import { render, staticRenderFns } from "./PersonalIdentificationDetails.vue?vue&type=template&id=11df907f&scoped=true&"
import script from "./PersonalIdentificationDetails.vue?vue&type=script&lang=js&"
export * from "./PersonalIdentificationDetails.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "11df907f",
  null
  
)

export default component.exports